import { SVGProps } from 'react'

export const Like = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
    <g clipPath="url(#clip0_116_11001)">
      <path
        fill="currentColor"
        d="M9.447.667l-4.78 4.786V14h8.206l2.46-5.733V5.333h-5.54l.747-3.586L9.447.667zM.667 6h2.666v8H.667V6z"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_116_11001">
        <path fill="#fff" d="M0 0H16V16H0z"></path>
      </clipPath>
    </defs>
  </svg>
)
